import { clx } from "@src/components/utils/stringUtils";
import {
	DELIVERY_CLASSIFICATION_HINT,
	DELIVERY_CLASSIFICATION_OPTIONS,
	DELIVERY_CLASSIFICATION_PROMPT,
	DeliveryClassification,
} from "@src/utils/deliveryClassification";
import React from "react";
import styles from "./DeliveryClassificationRadios.module.scss";

interface IDeliveryClassificationRadiosProps {
	name: string;
	value: DeliveryClassification | null;
	onChange: (value: DeliveryClassification) => void;
	hardTicketsDisabled?: boolean;
	error?: string | null;
}

export const DeliveryClassificationRadios: React.FC<IDeliveryClassificationRadiosProps> = ({
	name,
	value,
	onChange,
	hardTicketsDisabled = false,
	error,
}) => (
	<div className={styles.root}>
		<div className={styles.prompt}>
			{DELIVERY_CLASSIFICATION_PROMPT} <span className={styles.required}>*</span>
		</div>
		<div className={styles.radioGroup} role="radiogroup" aria-label={DELIVERY_CLASSIFICATION_PROMPT}>
			{DELIVERY_CLASSIFICATION_OPTIONS.map((option) => {
				const disabled = option.value === "HARD" && hardTicketsDisabled;
				const checked = value === option.value;
				return (
					<label
						key={option.value}
						className={clx(
							styles.radioOption,
							checked ? styles.radioOptionActive : undefined,
							disabled ? styles.radioOptionDisabled : undefined,
						)}>
						<input
							type="radio"
							name={name}
							value={option.value}
							checked={checked}
							disabled={disabled}
							onChange={() => onChange(option.value)}
						/>
						<span>{option.label}</span>
					</label>
				);
			})}
		</div>
		<div className={styles.hint}>{DELIVERY_CLASSIFICATION_HINT}</div>
		{error && <div className={styles.error}>{error}</div>}
	</div>
);
